var initProductCode = function ($) {
  let variantData = []
  let currentId = ''
  let currentCode = {}
  const product = document.location.pathname.split('/')
  $.getJSON(window.Shopify.routes.root + 'products/' + `${product[2]}.js`, function (product) {
    if (product !== undefined) {
      variantData = product.variants
      //set upload
      if (product.type === 'Custom Design') {
        setUploadInput()
      }
      initCode()
    }
  })

  function initCode() {
    new Promise((resolve, reject) => {
      var variant_ids = []
      variantData.forEach((ele) => {
        variant_ids.push(ele.id)
      })

      $.ajax({
        type: 'post',
        url: `https://api-beta.originlinks.com/shopify-app/shopify/code/display/show`,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify({
          app_admin_url: 'melodysusie.myshopify.com',
          position: 'pageCode',
          variant_ids: variant_ids
        }),
        success: function (res) {
          res.data.forEach((ele) => {
            variantData.forEach((inele, index) => {
              if (ele.variant_id === inele.id) {
                variantData[index].value = ele
              }
            })
          })
          const isVariant = getUrlParam('variant')
          if (isVariant !== null) {
            currentId = Number(isVariant)
            variantData.forEach((ele) => {
              if (ele.id === currentId) {
                currentCode = ele
              }
            })
          } else {
            currentCode = variantData[0]
          }
          if (res.data.length !== 0) {
            setCode()
          }
          resolve()
        },
        error: function (error) {
          console.log(error)
          reject()
        }
      })
    })
  }

  function setCode() {
    try {
      if (currentCode.value === undefined) {
        // find one set stlye
        let virtualPageDetail = {}
        variantData.forEach((ele) => {
          if (ele.value) {
            virtualPageDetail = ele.value.pageDetail
          }
        })
        $('.product-info .product-info__price').before(`
          <div id="ds_code" class="ds_code">
            <div>
              <div class="ds_question" id="ds_pop_open">
                <svg t="1655805015734" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2153" width="18" height="18"><path d="M514.048 54.272q95.232 0 178.688 36.352t145.92 98.304 98.304 145.408 35.84 178.688-35.84 178.176-98.304 145.408-145.92 98.304-178.688 35.84-178.176-35.84-145.408-98.304-98.304-145.408-35.84-178.176 35.84-178.688 98.304-145.408 145.408-98.304 178.176-36.352zM515.072 826.368q26.624 0 44.544-17.92t17.92-43.52q0-26.624-17.92-44.544t-44.544-17.92-44.544 17.92-17.92 44.544q0 25.6 17.92 43.52t44.544 17.92zM567.296 574.464q-1.024-16.384 20.48-34.816t48.128-40.96 49.152-50.688 24.576-65.024q2.048-39.936-8.192-74.752t-33.792-59.904-60.928-39.936-87.552-14.848q-62.464 0-103.936 22.016t-67.072 53.248-35.84 64.512-9.216 55.808q1.024 26.624 16.896 38.912t34.304 12.8 33.792-10.24 15.36-31.232q0-12.288 7.68-30.208t20.992-34.304 32.256-27.648 42.496-11.264q46.08 0 73.728 23.04t25.6 57.856q0 17.408-10.24 32.256t-26.112 28.672-33.792 27.648-33.792 28.672-26.624 32.256-11.776 37.888l1.024 38.912q0 15.36 14.336 29.184t37.888 14.848q23.552-1.024 37.376-15.36t12.8-32.768l0-24.576z" p-id="2154"></path></svg>
                <div class="ds_newtext">
                  <span id="ds_newtext"></span>
                  <span id="ds_newdtes"></span>
                </div>
              </div>
              <div></div>
            </div>
            <div class="ds_box">
              <div class="ds_off" style="background-image: url(${virtualPageDetail.baseMap1})">
                <div id="ds_off_text" class="ds_off_text" style="color:${virtualPageDetail.value.color}">${virtualPageDetail.value.value}% OFF</div>
                <div id="sp_ds_price" style="color:${virtualPageDetail.discount_price.color}">$ ${virtualPageDetail.discount_price.value}</div>
              </div>
              <div class="ds_codeWrapper" style="background-image: url(${virtualPageDetail.baseMap2})">
                <div id="ds_code_number" class="ds_code_number" style="color:${virtualPageDetail.code.color}">Code: ${virtualPageDetail.code.value}</div>
                <div class="ds_copy" style="color:${virtualPageDetail.copy.color};background-color:${virtualPageDetail.copy.base_color}">
                  <div class="ds_copy_text" id="copycode" >COPY</div>
                  <div class="ds_copy_text ds_copy_text_replace" id="ds_copy_text_replace">COPIED</div>
                </div>
              </div>
            </div>
          <div>
        `)
        $('#ds_code').css('display', 'none')
      } else {
        const pageDetail = currentCode.value.pageDetail
        $('.product-info .product-info__price').before(`
        <div id="ds_code" class="ds_code">
          <div>
            <div class="ds_question" id="ds_pop_open">
              <svg t="1655805015734" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2153" width="18" height="18"><path d="M514.048 54.272q95.232 0 178.688 36.352t145.92 98.304 98.304 145.408 35.84 178.688-35.84 178.176-98.304 145.408-145.92 98.304-178.688 35.84-178.176-35.84-145.408-98.304-98.304-145.408-35.84-178.176 35.84-178.688 98.304-145.408 145.408-98.304 178.176-36.352zM515.072 826.368q26.624 0 44.544-17.92t17.92-43.52q0-26.624-17.92-44.544t-44.544-17.92-44.544 17.92-17.92 44.544q0 25.6 17.92 43.52t44.544 17.92zM567.296 574.464q-1.024-16.384 20.48-34.816t48.128-40.96 49.152-50.688 24.576-65.024q2.048-39.936-8.192-74.752t-33.792-59.904-60.928-39.936-87.552-14.848q-62.464 0-103.936 22.016t-67.072 53.248-35.84 64.512-9.216 55.808q1.024 26.624 16.896 38.912t34.304 12.8 33.792-10.24 15.36-31.232q0-12.288 7.68-30.208t20.992-34.304 32.256-27.648 42.496-11.264q46.08 0 73.728 23.04t25.6 57.856q0 17.408-10.24 32.256t-26.112 28.672-33.792 27.648-33.792 28.672-26.624 32.256-11.776 37.888l1.024 38.912q0 15.36 14.336 29.184t37.888 14.848q23.552-1.024 37.376-15.36t12.8-32.768l0-24.576z" p-id="2154"></path></svg>
              <div class="ds_newtext">
                <span id="ds_newtext"></span>
                <span id="ds_newdtes"></span>
              </div>
            </div>
            <div></div>
          </div>
          <div class="ds_box">
            <div class="ds_off" style="background-image: url(${pageDetail.baseMap1})">
              <div id="ds_off_text" class="ds_off_text" style="color:${pageDetail.value.color}">${pageDetail.value.value}% OFF</div>
              <div id="sp_ds_price" style="color:${pageDetail.discount_price.color}">$ ${pageDetail.discount_price.value}</div>
            </div>
            <div class="ds_codeWrapper" style="background-image: url(${pageDetail.baseMap2})">
              <div id="ds_code_number" class="ds_code_number" style="color:${pageDetail.code.color}">Code: ${pageDetail.code.value}</div>
              <div class="ds_copy" style="color:${pageDetail.copy.color};background-color:${pageDetail.copy.base_color}">
                <div class="ds_copy_text" id="copycode" >COPY</div>
                <div class="ds_copy_text ds_copy_text_replace" id="ds_copy_text_replace">COPIED</div>
              </div>
            </div>
          </div>
        <div>
      `)
      }

      $('.ds_code #copycode').click(function () {
        copyText(currentCode.value.pageDetail.code.value)
        $('.ds_code #copycode').css('display', 'none')
        $('.ds_code #ds_copy_text_replace').css('display', 'block')
        let copytime = setTimeout(() => {
          $('.ds_code #copycode').css('display', 'block')
          $('.ds_code #ds_copy_text_replace').css('display', 'none')
          clearTimeout(copytime)
        }, 1500)
      })

      //pop open
      $('.ds_code #ds_pop_open').click(function () {
        $('#ds_pop').css('display', 'flex')
      })
    } catch (error) {
      console.log(error)
    }
  }

  // getUrlParam
  function getUrlParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
  }

  // copy-fs
  function copyText(text) {
    var textarea = document.createElement('input')
    // var currentFocus = document.activeElement
    $('#ds_code').append(textarea)
    textarea.value = text
    textarea.focus()
    if (textarea.setSelectionRange) textarea.setSelectionRange(0, textarea.value.length)
    else textarea.select()
    try {
      var flag = document.execCommand('copy')
    } catch (eo) {
      var flag = false
    }
    $('#ds_code input').remove()
    // currentFocus.focus()
    return flag
  }

  // pop close
  $('#ds_close').click(function () {
    $('#ds_pop').css('display', 'none')
  })
  $('#ds_overlay').click(function () {
    $('#ds_pop').css('display', 'none')
  })

  /***
   * Upload flie
   *
   *
   * **/

  function setUploadInput() {
    const fileNumber = 1
    if (!$('#infiniteoptions-container').children().length) {
      const uploadTime = setTimeout(() => {
        setUploadInput()
        clearTimeout(uploadTime)
      }, 500)
    } else {
      const formName = $('#infiniteoptions-container').attr('form')
      const containerLength = $('#infiniteoptions-container').children().length
      const currentIndex = containerLength + 1

      $('#infiniteoptions-container>div').eq(containerLength - 1).before(`
        <div>
          <div>
            <label class="spb-productdescfont spb-productdesctextcolor">Upload Images (Optional)</label>
          </div>
          <div id="msfile-box"></div>
        </div>
      `)
      $('#infiniteoptions-container').append(`
      <div id="msfilefile-from" class="msfilefile-from"></div>
    `)
      for (i = 0; i < fileNumber; i++) {
        $('#msfile-box').append(`
          <div class="gpo-form__group" id="grop-${currentIndex + i}">
            <div class="msfile-dropzone">
              <div class="msfile-stack msfile-stack--vertical">
                <div class="msfile-stack__item">
                  <div class="msfile-dropzone__action">Choose File</div>
                </div>
                <div class="msfile-stack__item">
                  <div class="msfile-dropzone__caption">or drop file to upload</div>
                </div>
              </div>
              <input type="file" data-type="file" id="file-${
                currentIndex + i
              }" class="msfile-file msfile-dropzone__input" name="Image Upload ${
          currentIndex + i
        }" data-field-name="Image Upload ${
          currentIndex + i
        }" placeholder="or drop files to upload" data-allowed_extensions="heic,jpeg,jpg,png" accept=".heic,.jpeg,.jpg,.png">
              
            </div>
            <div class="msfile-fpreview" id="msfile-fpreview-${currentIndex + i}">
              <a target="_blank" href="" class="msfile-fileImg">
                <img src="" class="msfile-fileurl">
              </a>
              <span class="msfile-fileName"></span>
              <button class="msfile-fileRemove" id="msfile-fileRemove-${currentIndex + i}">
                <svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><path d="M11.586 13l-2.293 2.293a1 1 0 0 0 1.414 1.414L13 14.414l2.293 2.293a1 1 0 0 0 1.414-1.414L14.414 13l2.293-2.293a1 1 0 0 0-1.414-1.414L13 11.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L11.586 13z" fill="currentColor" fill-rule="nonzero"></path></svg>
              </button>
            </div>
          </div>
        `)

        $(`#file-${currentIndex + i}`).bind('change', function (e) {
          const files = $(this).prop('files')
          const idNumber = $(this).attr('id').split('file-')
          if (files.length === 0) {
            return false
          } else {
            const num = Number(idNumber[1])
            $(`#grop-${num}`).append(`
              <div class="msfile-uploading" id="msfile-uploading">
                <span class="donut"></span>
                <span class="msfile-upload">Uploading...</span>
              </div>
            `)
            upImage(files[0], num, formName)
          }
        })

        $(`#msfile-fileRemove-${currentIndex + i}`).bind('click', function () {
          const idNumber = $(this).attr('id').split('msfile-fileRemove-')
          const num = Number(idNumber[1])
          $(`#msfile-fpreview-${num} .msfile-fileImg`).attr('href', '')
          $(`#msfile-fpreview-${num} .msfile-fileImg img`).attr('src', '')
          $(`#msfile-fpreview-${num} .msfile-fileName`).text('')
          $(`#grop-${num} .msfile-dropzone`).removeClass('msfile-uploadsuccess')
          $(`#grop-${num} .msfile-fpreview`).removeClass('msfile-showFpreview')
          $(`#selection${num}-0-1`).remove()
        })
      }
    }
  }

  function upImage(img, num, formName, i) {
    new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('img', img)
      $.ajax({
        type: 'post',
        url: `https://service.infiai.tech/msshoify/up_img`,
        cache: false,
        data: formData,
        contentType: false,
        processData: false,
        dataType: 'json'
      })
        .done(function (res) {
          if (res.status === 200) {
            const url = res.data
            const name = url.split('https://pocket-img.s3.us-east-2.amazonaws.com/')
            $(`#msfile-fpreview-${num} .msfile-fileImg`).attr('href', url)
            $(`#msfile-fpreview-${num} .msfile-fileImg img`).attr('src', url)
            $(`#msfile-fpreview-${num} .msfile-fileName`).text(name[1])
            $('#msfile-uploading').remove()
            $(`#grop-${num} .msfile-dropzone`).addClass('msfile-uploadsuccess')
            $(`#grop-${num} .msfile-fpreview`).addClass('msfile-showFpreview')
            $(`#msfilefile-from`).append(`
            <input type="text" name="properties[file${num}]" id="selection${num}-0-1" form="${formName}" value="${url}" style="display:none;">
          `)
            resolve()
          }
        })
        .fail(function (res) {
          reject()
        })
    })
  }

  document.addEventListener('variant:change', function (event) {
    let variant = event.detail.variant // Gives you access to the whole variant details
    variantData.forEach((ele) => {
      if (ele.id === variant.id) {
        currentCode = ele
      }
    })
    setCode()
  })
}

if (!window.jQuery) {
  // to be doned remove jquery
  var script = document.createElement('script')
  script.defer = true
  script.onload = function () {
    initProductCode(jQuery)
  }
  script.src = 'https://cdn.jsdelivr.net/npm/jquery@1.12.4/dist/jquery.min.js'
  // script.src = 'http://code.jquery.com/jquery-2.1.1.min.js'
  document.getElementsByTagName('head')[0].appendChild(script)
} else {
  initProductCode(jQuery)
}
